import React, { FunctionComponent } from 'react'

import { TextAlign, TitleSize } from '../../styles/typeStyles'
import { Size, Title } from '../title/Title'

/**
 * Simple Header text that is shown mostly in header components
 */
export const HeaderText: FunctionComponent<HeaderTextProps> = ({ color, size, text, wrap, textAlign }) => {
  return (
    <Title size={size ?? Size.SMALL} text={text} numberOfLines={1} color={color} wrap={wrap} textAlign={textAlign} />
  )
}

type HeaderTextProps = {
  text: string | React.ReactNode
  color?: string
  size?: TitleSize
  wrap?: boolean
  textAlign?: TextAlign
}
